module.exports = __webpack_public_path__ + "static/media/hrps_logo.d275c077.jpg";